const getPlayerNode = () => {
  return document.getElementById('player')
}

export default getPlayerNode
